module.exports = __webpack_public_path__ + "static/media/u40_premium_contract12.1477547d.webp";